import React,{useState,useEffect} from "react";
import logoschool from "../../assets/images/logosignup.png";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { SchoolSignupContext } from "../../context/SchoolSignupContext";
import axios from "axios";
import { toast } from "react-toastify";

import useThrottledClick from "../../hooks/useThrottledClick";
import { Eye, EyeOff } from "lucide-react";
import PasswordStrengthBar from "../../components/PasswordStrengthBar";
import { isStrongPassword } from "../../utils/validators";
import TrialExpiredModal from "../../components/TrialExpiredModal";
import { verifySchoolSubscriptionBlocked } from "../../utils/schoolSubscription";
import { useTrialExpiredModal } from "../../hooks/useTrialExpiredModal";

const SignupAccount =()=>{
  const navigate= useNavigate()
    const location =useLocation();
    const { signupData, setSignupData } = React.useContext(SchoolSignupContext);
    const [, setLoading] = useState(false);
    const [, setShowError] = useState(false);
    const [, setErrorMsg] = useState("");
    const [schoolType] = useState(signupData?.schoolType ? signupData?.schoolType : "");
    
    // const email = location.state?.email;
    // const [email, setEmail] = React.useState<string>("");
    // const [password, setPassword] = React.useState<string>("");
// console.log("location.state",location.state)
    // const [email,setEmail] = useState(location.state?.email ||"");

    const [email, setEmail] = useState(() => {
      const emailFromState = location.state?.email;
      
      if (emailFromState) {
        // State padh li, ab clear kar do — refresh pe nahi aayega
        window.history.replaceState({}, document.title);
      }
      
      return emailFromState || "";
    });

    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const {
      showTrialExpiredModal,
      setShowTrialExpiredModal,
      handleTrialRenew,
      handleTrialCancel,
      cancelLoading,
    } = useTrialExpiredModal(signupData);

    useEffect(() => {
      setSignupData((prev) => ({
        ...prev,
        email: email,
        password: password,
      }));
    }, [email, password, setSignupData]);


    const createUser = async () => {
      // e.preventDefault();
      // alert("createUser")
      setLoading(true)
      const baseURL = process.env.REACT_APP_BASE_URL;
  
      if (password.trim() !== "" && email) {
        if (password.trim() !== "" && password.trim().length >= 6) {
          try {
            const response = await axios.post(`${baseURL}/user/createUser`, {
              email: email.toLowerCase(),
              password: password,
              masterTypeid: schoolType?schoolType:"",
            }, {
              headers: {
                'Content-Type': 'application/json'
              }
            });

            localStorage.setItem("access_token", response.data.access_token);
            setLoading(false)
            if (response.data?.code !== 400) {
              navigate("/signUpOtp", { state: { email, Code: Number(response?.data?.data) } });
            } else {
              setShowError(true)
            }

            if(response.data?.code === 200){
              toast.success(response?.data?.message);

            }
            else{
              toast.error(response?.data?.message);

            }

          } catch (error) {
            setLoading(false)
            console.log("error")
            setErrorMsg("The email address provided is already in use")
            // console.error('Error creating user:', error.response ? error.response.data : error.message);

          }
        }
      } else {
        alert("Add password")
      }
    };

    const [emailError, setEmailError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);

    const handleContinue = async () => {
      // Simple regex for email validation
        await new Promise(res => setTimeout(res, 1000));
        if (emailError || passwordError) return;

        const baseURL = process.env.REACT_APP_BASE_URL;
        const blocked = await verifySchoolSubscriptionBlocked(baseURL, {
          ...signupData,
          schoolCode: signupData.schoolCode ?? signupData.verificationCode,
        });
        if (blocked) {
          setShowTrialExpiredModal(true);
          return;
        }

    //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    //   if (!email) {
    //     setEmailError("Please enter your email.");
    //     return;
    //   } else if (!emailRegex.test(email)) {
    //     setEmailError("Please enter a valid email address.");
    //     return;
    //   }
    
    //   if (!password) {
    //     setPasswordError("Please enter your password.");
    //     return;
    //   }
    //   else if (!isStrongPassword(password)) {
    //   setPasswordError(
    //     "Password must be at least 8 characters and include an uppercase letter, lowercase letter, number, and special character."
    //   );
    //   return;
    // }
      
      // else if (password.length < 6) {
      //   setPasswordError("Password must be at least 6 characters.");
      //   return;
      // }
    
      try {
        await createUser();

         
      } catch (error) {
        console.error("User creation failed:", error);
        // alert("Failed to create user.");
      }
    };
      const [throttledContinue, isLoading] = useThrottledClick(handleContinue, 3000);

      const handleEmailChange = (e) => {
  const value = e.target.value;
  setEmail(value);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!value) {
    setEmailError("Please enter your email.");
  } else if (!emailRegex.test(value)) {
    setEmailError("Please enter a valid email address.");
  } else {
    setEmailError("");
  }
};

const handlePasswordChange = (e) => {
  const value = e.target.value.slice(0, 40); // enforce max 40 characters
  setPassword(value);

  if (!value) {
    setPasswordError("Please enter your password.");
  } else if (!isStrongPassword(value)) {
    setPasswordError(
      "Password must be at least 8 characters and include an uppercase letter, lowercase letter, number, and special character."
    );
  } else {
    setPasswordError("");
  }
};


    return(<>
    <TrialExpiredModal
      open={showTrialExpiredModal}
      onActivatePlan={handleTrialRenew}
      onCancelSubscription={handleTrialCancel}
      cancelLoading={cancelLoading}
    />
    <div className="school-pages-inner">
        <div className="school-content-page">
        {/* <img src={logoschool}/>  */}
        	<img
  src={logoschool}
  alt="School Logo"
  style={{  cursor: "pointer" }}
  onClick={() => navigate("/school")}
/>
        <div className="schoo-outer">
            <div className="signup-outer-pagess">
                <h3>Create an Account </h3>
                <p className="set-your">Set your password to continue</p>
                <div className="email-inner" >
			<div className="input-container">
        <input type="email"
        value={email}
        // onChange={(e) => setEmail(e.target.value)}
                          onChange={handleEmailChange}

			  placeholder=" "
			/>
        <label >Email address*</label>
		
    </div>
    {emailError && <p className="error-message" style={{ color: "red" }}>{emailError}</p>}
    <div className="input-container email-cont">
                <input
                // type="password"
                // type="text"
                type={showPassword ? "text" : "password"}

                
                value={password}
                // onChange={(e) => setPassword(e.target.value)}
  onChange={handlePasswordChange}

                  placeholder=" "
                    maxLength={40}

                />
                <label >Password*</label>
                              <span 
                              onClick={() => setShowPassword(!showPassword)
                                
                              }>
  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
</span>

              </div>

              {passwordError && <p className="error-message" style={{ color: "red" }}>{passwordError}</p>}
                      <PasswordStrengthBar password={password} />

			<button className="continue-btn"
        onClick={throttledContinue}
       >
			  {/* Continue */}
              {isLoading ? '⏳ CONTINUING...' : 'CONTINUE'}

			</button>
		  </div>
		  
 
		  <p className="login-account" >
		Already have an account?
		  <a 
      href="/login-page"
      // href="/login-page" 

      		  		  		  onClick={(e) => {
    e.preventDefault(); // Prevent full page reload
    navigate("/login-page"); // Use client-side navigation
  }}
      style={{ color: "#2C68A1",cursor: 'pointer' }}>
		  Login 
			</a>
		  </p>

          <div className="or-inner" >
			<hr  />
			{/* <span >OR</span> */}
			<hr />
		  </div>

          

          <p className="term-part" >
	  <a href="/terms-of-use" >Terms of Use</a>  |  <a href="/privacy-policy" >Privacy Policy</a>
	</p>





            </div>

        </div>

        </div>

    </div>

    
    
    </>);

}
export default SignupAccount;